import gifConverter from '../views/gifConverter.vue';
import gifConverterPanel from '../components/rightPanel/gifConverterPanel.vue';
export default {
  path: '/gifconverter',
  components: {
    default: gifConverter,
    panel: gifConverterPanel
  }
};
